import { isValidAssetKey } from './asset-keys';

const DEFAULT_FALLBACK = null;

export function resolveAsset(themeAssets, key, fallback = DEFAULT_FALLBACK) {
	if (!isValidAssetKey(key)) {
		if (process.env.NODE_ENV !== 'production') {
			// eslint-disable-next-line no-console
			console.warn('[theme] invalid asset key:', key);
		}

		return fallback;
	}

	const val = themeAssets?.[key];

	return val ?? fallback;
}
